import React from 'react';
import AccountingModule from './accounting/Accounting';

const AccountsPayable = (props) => (
  <AccountingModule ledgerType="payables" {...props} />
);

export default AccountsPayable;
